module.exports = __webpack_public_path__ + "img/KC-Pro-tips-on-visibility.fccbc095.png";